import { State } from 'reducers';

export const getLanguage = (state: State) => state.shell.language;

export const getLoginName = (state: State) => state.shell.loginName;

export const getLoginPending = (state: State) => state.shell.loginPending;

export const getLoginError = (state: State) => state.shell.loginError;

export const isLoggedIn = (state: State) => state.shell.loggedIn;

export const isAdmin = (state: State) => state.shell.admin;

export const getTopBarVisible = (state: State) => state.shell.topBar;

export const getSessionId = (state: State) => state.shell.sessionId;

export const getInstantMessages = (state: State) => state.shell.messages;

export const getPermissions = (state: State) => state.shell.permissions;

export const isPasswordResetRequired = (state: State) => state.shell.isPasswordResetRequired;

export const isPasswordExpired = (state: State) => state.shell.isPasswordExpired;

export const isChangeImage = (state: State) => {
    try {
        return state.router.location.pathname.toLowerCase() === '/client/image';
    }
    catch {
        return false;
    }
};




// WEBPACK FOOTER //
// ./src/selectors/shellSelectors.ts